import { AppSettings } from "@/AppSettings";
import { useMemo } from "react";
import { createFormVersionConfiguration } from "./useFormVersionConfiguration";
import { ConfigurationSourceDataMap, Metadata, Trial } from "@/api/dtos";

const useFormVersionConfigurations = (
    metadata?: Metadata, 
    trialConfiguration?: ConfigurationSourceDataMap, 
    configuration?: ConfigurationSourceDataMap, 
    trial?: Trial, 
    configurationSourceDataId?: number,
    studyEventOid?: string,
    caseReportFormOid?: string
) => {
    return useMemo(() => {
        if (
            !caseReportFormOid || 
            !metadata || 
            (studyEventOid && !metadata.eventForms?.[studyEventOid]?.[caseReportFormOid]) ||
            !metadata.formVersions?.[caseReportFormOid]
        ) {
            return undefined;
        }

        return (
            Object.keys(metadata.formVersions[caseReportFormOid]).map(caseReportFormVersionOid => {
                return createFormVersionConfiguration(
                    metadata, 
                    trialConfiguration?.formVersions, 
                    configuration?.formVersions, 
                    trial, 
                    configuration?.configuration?.isGlobal,
                    configuration?.configuration?.id ?? configurationSourceDataId, 
                    studyEventOid,
                    caseReportFormOid,
                    caseReportFormVersionOid
                );
            }) as Array<NonNullable<ReturnType<typeof createFormVersionConfiguration>>>
        )
        .filter(x => !!x)
        .sort((a, b) => a.formVersionMetadata.order! < b.formVersionMetadata?.order! ? -1 : 1)
    }, [metadata, trialConfiguration?.formVersions, configuration?.formVersions, trial, configurationSourceDataId, studyEventOid, caseReportFormOid]) 
};

export default useFormVersionConfigurations;